import React from 'react'
import ReactDatePicker from 'react-datepicker';
import PropTypes from "prop-types"
import moment from 'moment';
import { useSelector } from 'react-redux';

export const GetCurrentDate = (date)=>{
    var currentDate = new Date(date);

  // Get the year, month, and day
  var year = currentDate.getFullYear();
  var month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
  var day = currentDate.getDate().toString().padStart(2, '0');

  // Format the date as "yyyy-mm-dd"
  return year + '-' + month + '-' + day;
}
export const GetCurrentTime = (date)=>{
  var currentTime = new Date(date);

  // Get the hours and minutes
  var hours = currentTime.getHours().toString().padStart(2, '0');
  var minutes = currentTime.getMinutes().toString().padStart(2, '0');
  
  // Format the time as "HH:mm"
  return hours + ':' + minutes;
}
export default function DateTimeInput(props) {
    const lang = useSelector((state)=>state?.languageState?.language);
    const {
        className,
        formClassName,
      } = props;
      const callChangeTime = (e) =>{
        if(!props?.format){
            props.format = "hh:mm A";
        }
        const data = {
          target:{
            name:props?.name,
            value:e? moment(e).locale("en").format(props?.format) :""
          }
        }
        props?.onChange(data);
      }
      const callChangeDate = (e) =>{
        const data = {
          target:{
            name:props?.name,
            value:e?GetCurrentDate(e):""
          }
        }
        props?.onChange(data);
    }
    const InputForm = () => {
        if(props?.type === "time"){
          const Data = {
            value:""
          }
          if(props?.value){
            Data.value = new Date(`${moment(new Date())?.format("YYYY-MM-DD")} ${props?.value}`)
          }
          // eslint-disable-next-line
          if(Data?.value == "Invalid Date"){
            Data.value = ""
          }
          return (
            <ReactDatePicker
              dateFormat={props?.dateFormat}
                timeFormat={"hh:mm a"}
          //   timeFormat='HH:mm A'
              timeIntervals={props?.timeIntervals}
              onChange={callChangeTime}
              selected={Data?.value}
              showTimeSelectOnly
              showTimeSelect
              className={`form-control ${className} w-100`}
              wrapperClassName="d-block"
              placeholderText={props?.placeholder}
            //   isClearable={value?true:false}
              showIcon
              locale={lang?.toLowerCase()}
            />
          )
        }
        if(props?.type === "date"){
          let value = "";
          if(props?.value){
            value = new Date(props?.value)
          }
          // eslint-disable-next-line
          if(value == "Invalid Date"){
            value = ""
          }

          return (
            <ReactDatePicker
              showIcon
              dateFormat={"yyyy-MM-dd"}
              onChange={callChangeDate}
              selected={value}
              className={`form-control ${className} w-100`}
              wrapperClassName="d-block"
              placeholderText="YYYY-MM-DD"
              isClearable={value?true:false}
              locale={lang?.toLowerCase()}
            />
          )
        }
    }
  return (
    <div className={`d-inline-block w-auto ${formClassName} position-relative`} >
        {InputForm()}
    </div>
  )
}
DateTimeInput.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.any,
  onChange: PropTypes.func,
  error: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  id: PropTypes.string,
  formClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  as: PropTypes.any,
  radius: PropTypes.number,
  size: PropTypes.any,
  labelFloat: PropTypes?.bool,
  value: PropTypes?.any,
  formStyle: PropTypes.any,
  style: PropTypes.any,
  required: PropTypes?.bool,
  inputType: PropTypes?.string,
  option: PropTypes?.array,
  leftIcon: PropTypes?.any,
  rightIcon: PropTypes?.any,
  leftLabel: PropTypes?.any,
  rightLabel: PropTypes?.any,
  is_special: PropTypes?.any,
  minDate: PropTypes?.any,
  leftIconClass: PropTypes?.any,
  rightIconClass: PropTypes?.any,
  onEditorChange: PropTypes.func,
  rightIconClick: PropTypes.func,
  leftIconClick: PropTypes.func,
  multiple: PropTypes?.bool,
  inline: PropTypes?.bool,
  hidden: PropTypes?.bool,
  disabled:PropTypes?.bool,
  locale:PropTypes?.any,
  timeIntervals:PropTypes?.any,
  format:PropTypes?.any,
};
DateTimeInput.defaultProps = {
  className: "",
  label: "",
  placeholder: "",
  onChange: () => {},
  onEditorChange: () => {},
  error: "",
  name: "name",
  type: "date",
  minDate: null,
  is_special: true,
  id: "",
  formClassName: "",
  labelClassName: "",
  errorClassName: "",
  as: "",
  radius: 1,
  size: 2,
  labelFloat: false,
  value: "",
  formStyle: "normal",
  style: {},
  required: false,
  inputType: "input",
  option: [],
  leftIcon: "",
  rightIcon: "",
  leftIconClass: "",
  rightIconClass: "",
  leftLabel: "",
  rightLabel: "",
  multiple: false,
  hidden:false,
  inline:false,
  disabled:false,
  locale:"",
  format:"",
  timeIntervals:5
};
